import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { parseDataSQL } from '../../utils/dataJogo';

function statusBadge(s) {
  if (s === 'APROVADO') return <span className="badge badge-success">Aprovado</span>;
  if (s === 'REJEITADO') return <span className="badge badge-danger">Rejeitado</span>;
  return <span className="badge badge-warning">Pendente</span>;
}

export default function AdminComprovantes() {
  const [comprovantes, setComprovantes] = useState([]);
  const [validando, setValidando] = useState(null);
  const [form, setForm] = useState({ status: 'APROVADO', observacao: '' });
  const [msg, setMsg] = useState('');

  useEffect(() => { carregar(); }, []);
  function carregar() { api.get('/comprovantes').then(setComprovantes).catch(() => {}); }

  async function validar(e) {
    e.preventDefault(); setMsg('');
    try {
      await api.patch(`/comprovantes/${validando.id}/validar`, form);
      setMsg('Comprovante atualizado!'); setValidando(null); carregar();
    } catch (err) { setMsg(err.message); }
  }

  return (
    <div>
      <h2 className="admin-title">Comprovantes PIX</h2>
      {msg && <div className="alert alert-success">{msg}</div>}
      {validando && (
        <form onSubmit={validar} className="admin-form">
          <h3>Validar Comprovante de {validando.usuario_nome}</h3>
          <div className="form-group">
            <label>Status</label>
            <select value={form.status} onChange={e => setForm({ ...form, status: e.target.value })}>
              <option value="APROVADO">Aprovar</option>
              <option value="REJEITADO">Rejeitar</option>
            </select>
          </div>
          <div className="form-group"><label>Observação (opcional)</label><textarea value={form.observacao} onChange={e => setForm({ ...form, observacao: e.target.value })} rows={3} /></div>
          <div className="admin-actions">
            <button type="submit" className="btn btn-primary">Confirmar</button>
            <button type="button" className="btn btn-secondary" onClick={() => setValidando(null)}>Cancelar</button>
          </div>
        </form>
      )}
      <div className="admin-table-wrap">
        <table>
          <thead><tr><th>Usuário</th><th>E-mail</th><th>Arquivo</th><th>Data</th><th>Status</th><th>Obs.</th><th>Ações</th></tr></thead>
          <tbody>
            {comprovantes.map(c => (
              <tr key={c.id}>
                <td>{c.usuario_nome}</td>
                <td style={{ fontSize: 12 }}>{c.usuario_email}</td>
                <td><a href={`https://api.damelsoft.com.br/uploads/comprovantes/${c.arquivo}`} target="_blank" rel="noreferrer" style={{ color: 'var(--primary)', fontSize: 12 }}>Ver arquivo</a></td>
                <td style={{ fontSize: 12 }}>{parseDataSQL(c.created_at).toLocaleDateString('pt-BR')}</td>
                <td>{statusBadge(c.status)}</td>
                <td style={{ fontSize: 12, color: 'var(--text2)' }}>{c.observacao || '—'}</td>
                <td>
                  {c.status === 'PENDENTE' && (
                    <button className="btn btn-primary" style={{ fontSize: 12, padding: '6px 12px' }}
                      onClick={() => { setValidando(c); setForm({ status: 'APROVADO', observacao: '' }); }}>
                      Validar
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
